import NumberFilter from '@inovua/reactdatagrid-enterprise/NumberFilter';
import DataTable from 'components/DataTable';
import { IConfigurationRequestTotal } from '../../../../server/types';

type ConfigTotalsTableProps = {
  rows?: IConfigurationRequestTotal[];
  loading?: boolean;
};

const defaultColumnInfo = {
  defaultFlex: 1,
};

const columns = [
  {
    header: 'Design',
    name: 'productName',
    type: 'string',
    minWidth: 160,
    ...defaultColumnInfo,
  },
  {
    header: 'Overall',
    name: 'overall',
    minWidth: 100,
    ...defaultColumnInfo,
    type: 'number',
    operator: 'gt',
    filterEditor: NumberFilter,
  },
];

const ConfigTotalsTable = ({ rows = [], loading = false }: ConfigTotalsTableProps) => {
  const tableActions = [
    {
      type: 'filter',
      callback: () => {},
    },
  ];

  return (
    <DataTable
      id="config-totals-archive-3"
      rows={rows}
      exportParams={{
        model: 'ConfigRequestTotals',
      }}
      columns={columns}
      loading={loading}
      actions={tableActions}
      tableProps={{
        idProperty: 'productName',
      }}
    />
  );
};

export default ConfigTotalsTable;
